import backendHttpClient from '../../../http/axios/axios-http-client';
import { SessionType } from './dto/session-type.dto';

const SECURED_ENDPOINT = '/session-type';

export interface SessionTypeGateway {
  getAll(): Promise<SessionType[]>;
}

export class SessionTypeGateway implements SessionTypeGateway {
  async getAll(): Promise<SessionType[]> {
    const endpoint = SECURED_ENDPOINT;
    const response = await backendHttpClient.request({
      url: endpoint,
      method: 'GET',
    });
    return response.data;
  }
}
